import { useTranslation } from 'react-i18next'

import { Link } from 'src/components/Link/Link'
import { Text } from 'src/components/Text/Text'

import styles from './DonationRibbon.module.scss'

export const DonationRibbon = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.ribbon}>
      <div className={styles.wrapper}>
        <div className={styles.badge}>
          <img
            src="/assets/svg/illustrations/1-euro-donation-with-arrow.svg"
            alt="1 Euro Spende pro Kilo"
            height={89}
            width={80}
          />
        </div>

        <div className={styles.textWrapper}>
          <Text>{t('pdp.donationRibbon.text')}</Text>{' '}
          <Link href={t('pdp.donationRibbon.link')} inverted>
            {t('common.learnMore')}
          </Link>
        </div>
      </div>
    </div>
  )
}
